import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // 에러 발생 시 더 자세한 컨텍스트 정보 로깅
        console.error("ErrorBoundary caught an error", error, errorInfo);

        // [NEW] 로컬스토리지에서 사용자 정보 가져와서 로깅 (디버깅 용도)
        try {
            const guestProfile = localStorage.getItem("guest_userProfile");
            if (guestProfile) {
                const profile = JSON.parse(guestProfile);
                console.error("[ErrorBoundary] Guest User Context:", {
                    provider: profile.provider || 'unknown',
                    deptName: profile.deptName || 'unknown'
                });
            }
        } catch (e) {
            // 로깅 실패는 무시
        }

        // [NEW] 에러 발생 시간과 페이지 URL 로깅
        console.error("[ErrorBoundary] Error Time:", new Date().toISOString());
        console.error("[ErrorBoundary] Page URL:", window.location.href);
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-[400px] w-full flex flex-col items-center justify-center p-8 text-center bg-white/50 backdrop-blur-md rounded-[2.5rem] border border-red-100 shadow-sm">
                    <div className="w-16 h-16 bg-red-50 rounded-2xl flex items-center justify-center text-red-500 mb-6 animate-bounce">
                        <AlertTriangle size={32} />
                    </div>
                    <h2 className="text-2xl font-black text-gray-800 mb-3 font-do-hyeon">앗! 문제가 발생했습니다</h2>
                    <p className="text-gray-500 mb-8 max-w-sm leading-relaxed text-sm font-medium">
                        화면을 불러오는 중 오류가 발생했습니다.<br />
                        잠시 후 다시 시도해 주세요.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 w-full max-w-xs">
                        <button
                            onClick={this.handleReset}
                            className="flex-1 flex items-center justify-center gap-2 py-4 bg-[#354F38] text-white font-bold rounded-2xl shadow-lg shadow-[#354F38]/20 hover:opacity-90 active:scale-95 transition-all"
                        >
                            <RefreshCw size={18} />
                            다시 시도
                        </button>
                        <button
                            onClick={() => window.location.href = '/'}
                            className="flex-1 flex items-center justify-center gap-2 py-4 bg-gray-100 text-gray-600 font-bold rounded-2xl hover:bg-gray-200 active:scale-95 transition-all"
                        >
                            <Home size={18} />
                            홈으로
                        </button>
                    </div>
                    {process.env.NODE_ENV === 'development' && (
                        <div className="mt-8 p-4 bg-red-50 rounded-xl text-left overflow-auto max-w-full">
                            <p className="text-[10px] font-mono text-red-800 break-all">
                                {this.state.error && this.state.error.toString()}
                            </p>
                        </div>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
